import { ISurveyAnswerOption } from "@common/models/CMS/SurveyAnswerOption"
import { ISurveyQuestionMultiOption } from "@common/models/CMS/SurveyQuestionMultiOption"
import CheckboxInput from "@components/general/form/CheckboxInput"
import { FC } from "react"
import { ISurveyMultiAnswer } from "@common/models/SurveyConfirm"

interface ISurveyQuestionMultiAnswerProps {
    multiAnswers: ISurveyMultiAnswer[];
    question: ISurveyQuestionMultiOption;
    onChangeMultiAnswer: (questionId: number, answer: ISurveyAnswerOption) => void;
    className?: string;
}


export const SurveyQuestionMultiAnswer: FC<ISurveyQuestionMultiAnswerProps> = ({ multiAnswers, question, className, onChangeMultiAnswer }) => {

    return (
        <div className={`survey-question-multi-answer ${className || ""} col-md-1-1 col-sm-1-1`}>
            <main className={`row spa-1 flex multi-answer ${question.answerNewLine ? " new-line" : " flex-no-wrap"} flex-center flex-grow justify-between`}>
                <section className={`col-1-auto flex flex-center question-title`}>{question.text}</section>
                <section className="col-1-auto answer-items">
                    <div className="row flex flex-grow spa-1 answer-items-container">
                        {question.bag.contentItems.map((answer => <div
                            key={answer.id}
                            className={`col-1-${question.bag.contentItems.length}${` col-sm-1-${question.answerColumnCount}`} answer-item`}

                        >
                            <CheckboxInput
                                name={question.id.toString()}
                                id={answer.id.toString()}
                                value={multiAnswers.find(question => question.answerIds.find(a => a === answer.id))}
                                label={answer.displayText}
                                onChange={() => onChangeMultiAnswer(question.id, answer)}
                            />
                        </div>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    )
}